export default "__VITE_PUBLIC_ASSET__0955f6bc__"